$('.elem-input__field').blur(function () {
  let val = $(this).val();

  if (val !== '') {
    $(this).addClass('empty');
  } else {
    $(this).removeClass('empty');
  }
});